import React from "react";

const TabEmpresas = ({
  searchTermEmpresa,
  setSearchTermEmpresa,
  filterGiro,
  setFilterGiro,
  filterEstado,
  setFilterEstado,
  sortField,
  sortDirection,
  handleSortEmpresas,
  handleSort,
  filteredEmpresas,
  handleOpenEditEmpresa,
  confirmDeleteEmpresa,
}) => {
  return (
    <>
      <div className="mb-5">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <div className="w-full md:w-1/2">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-search text-gray-400 text-xl"></i>
              </div>
              <input
                type="text"
                className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                placeholder="Buscar por empresa, giro o estado"
                value={searchTermEmpresa}
                onChange={(e) => setSearchTermEmpresa(e.target.value)}
              />
            </div>
          </div>
          <div className="w-full md:w-1/2 flex space-x-4">
            <div className="relative w-1/2">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-filter-alt text-gray-400 text-xl"></i>
              </div>
              <select
                className="appearance-none w-full pl-12 pr-10 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm cursor-pointer"
                value={filterGiro}
                onChange={(e) => setFilterGiro(e.target.value)}
              >
                <option value="">Todos los Giros</option>
                <option value="servicios">Servicios</option>
                <option value="tecnologia">Tecnología</option>
                <option value="construccion">Construcción</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            <div className="relative w-1/2">
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <i className="bx bx-map-pin text-gray-400 text-xl"></i>
              </div>
              <select
                className="appearance-none w-full pl-12 pr-10 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 text-sm cursor-pointer"
                value={filterEstado}
                onChange={(e) => setFilterEstado(e.target.value)}
              >
                <option value="">Todos los Estados</option>
                <option value="CIUDAD DE MÉXICO">Ciudad de México</option>
                <option value="ESTADO DE MÉXICO">Estado de México</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center w-full">
        <div className="w-full overflow-hidden rounded-lg shadow">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 border-b">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("id_empresa")}
                >
                  <div className="flex items-center justify-between">
                    <span>ID</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "id_empresa" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("nombre")}
                >
                  <div className="flex items-center justify-between">
                    <span>EMPRESA</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "nombre" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("giro")}
                >
                  <div className="flex items-center justify-between">
                    <span>GIRO</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "giro" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("especialidad")}
                >
                  <div className="flex items-center justify-between">
                    <span>ESPECIALIDAD</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "especialidad" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("estado")}
                >
                  <div className="flex items-center justify-between">
                    <span>ESTADO</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "estado" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSortEmpresas("direccion")}
                >
                  <div className="flex items-center justify-between">
                    <span>DIRECCIÓN</span>
                    <span className="ml-2 text-gray-500">
                      {sortField === "direccion" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 font-semibold cursor-pointer hover:bg-gray-100 text-center"
                  onClick={() => handleSort("estatus")}
                >
                  <div className="flex items-center justify-center">
                    <span>Acciones</span>
                    <span className="ml-8 text-gray-500">
                      {sortField === "estatus" ? (
                        sortDirection === "asc" ? (
                          <i className="bx bxs-up-arrow text-blue-600"></i>
                        ) : (
                          <i className="bx bxs-down-arrow text-blue-600"></i>
                        )
                      ) : (
                        <i className="bx bx-sort-alt-2 text-gray-400"></i>
                      )}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredEmpresas.length > 0 ? (
                filteredEmpresas.map((item) => (
                  <tr
                    key={item.id_empresa}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 font-medium">{item.id_empresa}</td>
                    <td className="px-6 py-4">{item.nombre}</td>
                    <td className="px-6 py-4">{item.giro}</td>
                    <td className="px-6 py-4">{item.especialidad}</td>
                    <td className="px-6 py-4">{item.estado}</td>
                    <td className="px-6 py-4">{item.direccion}</td>
                    <td className="px-6 py-4 flex justify-center gap-x-2">
                      <button
                        onClick={() => handleOpenEditEmpresa(item)}
                        className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white rounded-lg h-9 w-9 transition-colors"
                        title="Editar empresa"
                      >
                        <i className="bx bx-edit text-lg"></i>
                      </button>
                      <button
                        onClick={() =>
                          confirmDeleteEmpresa(item.id_empresa, item.nombre)
                        }
                        className="inline-flex items-center justify-center bg-red-600 hover:bg-red-700 text-white rounded-lg h-9 w-9 transition-colors"
                        title="Eliminar empresa"
                      >
                        <i className="bx bx-trash text-lg"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="border-b">
                  <td
                    colSpan={7}
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    {searchTermEmpresa
                      ? "No se encontraron resultados para tu búsqueda"
                      : "No hay empresas registradas"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TabEmpresas;
